<template>
    <ButtonIcon
        v-if="widgetCloseButtonAvailable"
        class="widget-close-button"
        aria-label="close widget"
        data-testid="widget-close-button"
        @click="closeWidget"
    >
        <i class="mi-close" />
    </ButtonIcon>
</template>

<script lang="ts" setup>
import ButtonIcon from './ButtonIcon.vue'
import useCloseWidgetButton from '@/composables/widget-close-button'

const { widgetCloseButtonAvailable, closeWidget } = useCloseWidgetButton()
</script>

<style lang="scss" scoped>
.widget-close-button {
    position: absolute;
    top: var(--top-buttons-padding);
    right: var(--top-buttons-padding);
    z-index: var(--layer-widget-close-button);
}

:global(html) {
    --top-buttons-padding: 12px;
}
</style>
